import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Folder = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.762 9.778H17.087l-1.7-3.743c-.418-1.131-1.373-1.845-2.554-1.845H2.714C1.173 4.19 0 5.482 0 6.98v28.297c0 2.458 1.919 4.532 4.381 4.532h35.238c2.462 0 4.381-2.074 4.381-4.532V14.368c0-2.607-2.152-4.59-5.238-4.59ZM2.714 6.286c-.298 0-.619.266-.619.694v2.798h12.69L13.443 6.82l-.015-.043c-.137-.39-.357-.492-.594-.492H2.714Zm-.619 28.991V11.873h21.302v11.524l4.889-4.4 4.889 4.4V11.873h5.587c2.152 0 3.143 1.256 3.143 2.495v20.91c0 1.389-1.068 2.436-2.286 2.436H4.381c-1.218 0-2.286-1.047-2.286-2.437Z"
  }));
});
Folder.displayName = 'Folder';
Folder.defaultProps = {
  'aria-label': 'Folder'
};
export default Folder;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Folder.js
// module id = 3798
// module chunks = 11